import React from 'react';
interface SectionHeadingProps {
  title: string;
  eyebrow?: string;
  description?: string;
  id?: string;
  size?: 'md' | 'lg';
}
export function SectionHeading({
  title,
  eyebrow,
  description,
  id,
  size = 'md'
}: SectionHeadingProps) {
  return <div className="mx-auto flex max-w-3xl flex-col items-center gap-2 text-center" data-id="element-194" data-mp="3f36rdlf93t87">
      {eyebrow && <p className="text-[0.65rem] font-extrabold uppercase tracking-[0.24em] text-volt sm:text-xs" data-id="element-195" data-mp="3k202x8az9a5q">
          {eyebrow}
        </p>}
      <h2 id={id} className={`font-display uppercase leading-[1.05] text-white ${size === 'lg' ? 'text-2xl sm:text-4xl lg:text-5xl' : 'text-xl sm:text-3xl lg:text-4xl'}`} data-id="element-196" data-mp="gjq1twp2yhi7">
        {title}
      </h2>
      <span aria-hidden="true" className="h-1 w-14 rounded-full bg-volt" data-id="element-197" data-mp="uj7w2rl5amyy" />
      {description && <p className="text-sm leading-snug text-steel sm:text-base" data-id="element-198" data-mp="z9xzw0dxahrj">
          {description}
        </p>}
    </div>;
}